import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { NOT_PICKED_REPORT } from "../../helpers/url_helper";
import CommanDataTable from "../../Components/Common/DataTable";
import moment from "moment";
import { formatDate } from "../../Components/Common/FormDateTime";
import { APIClient } from "../../helpers/api_helper";
import {
  getPreviousDate,
  setCurrentDate,
} from "../../Components/Common/DefaultDateSet";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import { useNavigate } from "react-router-dom";
import SubExpired from "../../Components/Common/subExpired";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";

const api = new APIClient();

const ConsolidateNotPickedUp = ({
  appliedFilters,
  selectedFromDate,
  selectedEmployeeOptions,
  selectedToDate,
  teamIndu,
}) => {
  console.log(appliedFilters?.employees, "appliedFilters");
  console.log(selectedEmployeeOptions, "selectedEmployeeOptions");

  document.title = "Not Picked Up by Client";
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const BooleanWithSingleEmployeeLogin =
    loginType === "employee" && permissionType.length === 0;

  const { profileData } = useProfileData();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  //search field state
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  
  //select team state

  // employee select
  const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);

  // Pagination settings
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState("");
  // table data state
  const [notPickupedData, setNotPickupedData] = useState();


  // flatPicker Date
  const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);
  const remainingDays = CalculateRemainingDays();



  const column = [
    {
      name: <span className="font-weight-bold fs-13"> SN.</span>,
      width: "5%",
      selector: (row, index) => index + 1,
      sortable: true, // This sets the width of the "Sr. No" column to 30px
    },
    {
      name: (
        <span
          className="font-weight-bold fs-13 text-center fs-2 fs-2"
          style={{ textTransform: "capitalize" }}
        >
          Employee
        </span>
      ),
      selector: (row) => row?.employeeName,
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.employeeName}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.countryCode + `-` + row?.employeeNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13"> Team Name</span>,
      selector: (row) => row.team,
    },
    {
      name: (
        <span className="font-weight-bold fs-13 text-center fs-2 fs-2">
          Client Name
        </span>
      ),
      selector: (row) => row?.clientName,
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.clientName}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.phoneNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 fs-2">Date</span>,
      selector: (row) => row.dt,
      sortable: true,
      sortFunction: (a, b) => {
        const dateTimeA = a.dt && a.tm ? moment(`${a.dt} ${a.tm}`, "DD MMM YYYY hh:mm:ss A").toDate().getTime() : 0;
        const dateTimeB = b.dt && b.tm ? moment(`${b.dt} ${b.tm}`, "DD MMM YYYY hh:mm:ss A").toDate().getTime() : 0;
        return dateTimeA - dateTimeB; // Use dateTimeB - dateTimeA for descending
      },
    },
    {
      name: <span className="font-weight-bold fs-13 fs-2">Time</span>,
      selector: (row) => row?.tm,
      sortable: false,
    },
    // {
    //     name: <span className='font-weight-bold fs-13 text-center fs-2'>Duration</span>,
    //     selector: row => row.duration,
    //     sortable: true
    // },
    {
      name: <span className="font-weight-bold fs-13 fs-2">Call Type</span>,
      selector: (row) => (
        <div>
          <i className="mdi mdi-phone-outgoing sn-out-going-text" />{" "}
          <span className="text-warning gap-2 sn-out-going-call">
            {row.typ}
          </span>
        </div>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13 text-center fs-2">Notes</span>
      ),
      selector: (row) => row.note,
      sortable: true,
    },
  ];

  // subscription plan expire code


  // search function
  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  useEffect(() => {
    if (teamIndu) {
      if (!isFirstEffectRun && selectedEmployeeOptions?.length > 0) {
        let updatedIds =
          selectedEmployeeOptions?.map((option) => option?.id) || [];
        if (updatedIds.length > 0) {
          let dateObj = {
            startDate: formatDate(selectedFromDate),
            endDate: formatDate(selectedToDate),
          };
          notPickedData(currentPage, 10, "", updatedIds, dateObj);
        }
        setIsFirstEffectRun(true); // Mark as executed
      }
    } else {
      let updatedIds =
        selectedEmployeeOptions?.map((option) => option?.id) || [];
      if (updatedIds.length > 0) {
        let dateObj = {
          startDate: formatDate(selectedFromDate),
          endDate: formatDate(selectedToDate),
        };
        notPickedData(currentPage, 10, "", updatedIds, dateObj);
      }
      setIsFirstEffectRun(true); // Mark as executed
    }
  }, [selectedEmployeeOptions, appliedFilters]);

  // Debounce search query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
      setCurrentPage(1);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  useEffect(() => {
    if (BooleanWithSingleEmployeeLogin) {
      loginEmplolye();
      return;
    } else {
      if (isFirstEffectRun === true) {
        let updatedIds =
          selectedEmployeeOptions?.map((option) => option?.id) || [];
        const fetchData = async () => {
          if (debouncedQuery.length >= 3 || debouncedQuery.length === 0) {
            let dateObj = {
              startDate: formatDate(selectedFromDate),
              endDate: formatDate(selectedToDate),
            };
            await notPickedData(
              currentPage,
              perPage,
              debouncedQuery,
              updatedIds,
              dateObj
            );
          }
        };
        fetchData();
      }
    }

    async function loginEmplolye() {
      let dateObj = {
        startDate: formatDate(selectedFromDate),
        endDate: formatDate(selectedToDate),
      };
      await notPickedData(
        currentPage,
        perPage,
        debouncedQuery,
        profileData._id,
        dateObj
      );
    }
  }, [debouncedQuery, currentPage, perPage, appliedFilters]);

  // Pagination handler
  const handlePageChange = async (page) => {
    setCurrentPage(page);
  };

  // Row per Changes
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  // Api Call in Not Pickkedup
  const notPickedData = async (
    page,
    size = perPage,
    searchTerm = "",
    updatedIds,
    dateObj
  ) => {
    setIsLoading(true);
    try {
      if (!updatedIds) {
        updatedIds = selectedEmployeeOptions2.map((userid) => userid?.id);
      }
      const id = appliedFilters?.employees.map((userid) => userid?.id);
      let data = {
        startDate: appliedFilters
          ? formatDate(appliedFilters.fromDate)
          : dateObj?.startDate
          ? dateObj?.startDate
          : "",
        endDate: appliedFilters
          ? formatDate(appliedFilters.toDate)
          : dateObj?.endDate
          ? dateObj?.endDate
          : "",
        employeeIds: id ? id : updatedIds,
      };
      const response = await api.create(
        `${NOT_PICKED_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`,
        data
      );
      if (response && response?.success === true) {
        setIsLoading(false);
        const apiResponse = response?.data;
        const tableData = (apiResponse?.paginatedResults || []).map(
          (data, index) => {
            const recordingUserStatus = data?.recordingStatus?.replace(
              /_/g,
              " "
            );
            // console.log("data?.employeeDescription[0]?.countryCode",data?.employeeDescription[0]?.countryCode);

            return {
              serialNumber: index + 1,
              employeeName: Array.isArray(data?.employeeDescription)
                ? data.employeeDescription[0]?.fullName
                : "unknown",
              employeeNumber: Array.isArray(data?.employeeDescription)
                ? data.employeeDescription[0]?.mobileNumber
                : "-",
              clientName: data?.name ?? "unknown",
              phoneNumber: data?.phoneNumber ?? "-",
              countryCode: data?.employeeDescription[0]?.countryCode,
              dt: moment(data?.dateTime).format("DD MMM YYYY") ?? "-",
              tm: moment(data?.dateTime).format("hh:mm A") ?? "-",
              duration: data?.duration ?? "-",
              note: data?.note ?? "-",
              recordingStatus: recordingUserStatus ?? "-",
              typ: data?.type ?? "-",
              team:data?.employeeDescription[0]?.team[0] || 'No Team'
            };
          }
        );
        setNotPickupedData(tableData);
        setTotalRows(apiResponse?.totalCount);
      }
    } catch (error) {
      if (!remainingDays === 0) {
        HandleErrorMessage(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { 
    if (BooleanWithSingleEmployeeLogin) {
      let dateObj = {
        startDate: formatDate(selectedFromDate),
        endDate: formatDate(selectedToDate),
      };
      notPickedData(currentPage, 10, "", profileData._id, dateObj);
    }
  }, [profileData]);

  // expire plan  function
  const handleClose = () => {
    setIsExpiredModalOpen(false);
    navigate("/planPackage");
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid>
         
          <Row>
            <Col lg={12}>
              <Card className="h-100">
                <CardBody>
                  <Row className="sn-team-managment-tble sn-user-tble-manin-manage">
                    <Col lg={12}>
                      <div className="search-datatable-wrapper">
                        <CommanDataTable
                          setCurrentPage={setCurrentPage}
                          perPage={perPage}
                          handleSearch={handleSearch}
                          searchText={query}
                          column={column}
                          tableData={notPickupedData}
                          handlePerRowsChange={handlePerRowsChange}
                          totalRows={totalRows}
                          currentPage={currentPage}
                          isLoading={isLoading}
                          handlePageChange={handlePageChange}
                          noData="There are no records to display"
                          inputClass={
                            (notPickupedData && notPickupedData?.length > 0) ||
                            query
                              ? "d-block mb-4" // Added margin-bottom class
                              : "d-none"
                          }
                        />
                      </div>
                    </Col>
                    {/* </div> */}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConsolidateNotPickedUp;
